<div class="wrapper">
  <div class="emr-page-container">

    @if (!loaded()) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    } @else {
      @if (patient(); as localPatient) {
      <div class="emr-page-title">
        Select Medications for {{localPatient.firstName}} {{localPatient.lastName }}
      </div>

      <p-dataView #providerOrdersList [value]="localPatient.providerOrders">

        <ng-template #header>
          @if (providerOrderSelections.value && providerOrderSelections.value.length > 0) {
          <button
            pButton class="p-button-primary"
            [routerLink]="['/', 'release', 'release', localPatient.id, providerOrderSelections.value![0]]"
            [queryParams]="getMoreProviderOrderIds(providerOrderSelections.value!)"
            [disabled]="providerOrderSelections.value!.length === 0">
            Release Selection
          </button>
          }
        </ng-template>

        <ng-template let-providerOrder #list>
          @for (providerOrder of localPatient.providerOrders; track $index) {
          <div ngClass="providerOrder">
            <span>
              {{providerOrder.medName}}
            </span>
            <span>
              Quantity: {{providerOrder.quantity}}
            </span>
            <span>
              Dosage: {{providerOrder.dosage}}
            </span>
            <span>
              Time: {{providerOrder.startTime.hour.toString().padStart(2,
              '0')}}:{{providerOrder.startTime.minute.toString().padStart(2, '0')}}
            </span>
            @if (inStockProviderOrdersIds().includes(providerOrder.id)) {
            <p-checkbox [value]="providerOrder.id" [formControl]="providerOrderSelections"></p-checkbox>
            } @else {
            <span class="outOfStockText">Out Of Stock</span>
            }
          </div>
          }
        </ng-template>

      </p-dataView>

      }
    }

  </div>
</div>